import {Dot} from 'recharts';
import styled, {useTheme} from 'styled-components';

import {PriceReportType} from '../../../../../types/PriceReportType';
import {MY_VEHICLE_RADIUS} from '../consts/myVehicleRadius';
import {StatisticsChartItem} from '../types/StatisticsChartItem';
import {getChartItemColor} from '../utils/getChartItemColor';
import {MyVehicleShape} from './MyVehicleShape';

const DOT_RADIUS = 8;

interface ScatterShapeProps {
  x?: number; // Passed by recharts
  width?: number; // Passed by recharts
  y?: number; // Passed by recharts
  payload?: StatisticsChartItem;
  priceReport: PriceReportType;
  activeTooltipIndex: number | null;
  selectedVehicleIds: string[] | null;
}

export function ScatterShape(props: ScatterShapeProps) {
  const theme = useTheme();

  const isMyVehicle = props.payload?.car.isMyVehicle;
  const isMyAd = props.payload?.car.isMyAd;

  if (isMyVehicle) {
    return <MyVehicleShape {...props} chartType="scatter" />;
  }

  const color = props.payload
    ? getChartItemColor(
        theme,
        props.priceReport,
        props.payload?.car,
        props.activeTooltipIndex === props.payload?.index,
        !!props.selectedVehicleIds?.includes(props.payload.car.ad_id)
      )
    : undefined;

  return (
    <DotWithHover
      {...props}
      r={isMyAd ? MY_VEHICLE_RADIUS : DOT_RADIUS}
      fill={color}
      stroke={isMyAd ? theme.colors.palettes.green['40']['100'] : undefined}
      strokeOpacity={isMyAd ? 0.4 : undefined}
      strokeWidth={isMyAd ? 16 : undefined}
    />
  );
}

// ScatterChart has different onMouseMove prop (there is missing activeTooltipIndex attribute)
const DotWithHover = styled(Dot)`
  &:hover {
    fill: ${({theme}) => theme.colors.palettes.blue['40']['100']};
  }
`;
